import { Component, ReactNode } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { ProductRow } from "namirasoft-quota";
import { NSQAllUsageGauges } from "namirasoft-quota-react";
import { NSBoxEntity, NSRow, NSSection, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
// layout & props
import { QuotaLayout } from "../QuotaLayout";
import { QuotaRouterProps } from "../QuotaRouterProps";

export interface UsagePageProps extends NSARouterMakerResult, QuotaRouterProps { }

export interface UsagePageState
{
    selectedProductID: string;
}

export class UsagePage extends Component<UsagePageProps, UsagePageState>
{
    constructor(props: UsagePageProps)
    {
        super(props);
        this.state = { selectedProductID: "NONE" };
    }

    override render(): ReactNode
    {
        return (
            <QuotaLayout
                {...this.props}
                action={{
                    title: "Usage",
                    description: "This section displays graphs showing your usage of tiered Namirasoft products.",
                    menus: {}
                }}
            >
                <NSSection>
                    <NSBoxEntity<ProductRow>
                        title="Product"
                        multiple={false}
                        required={false}
                        table_name="product"
                        list={this.props.servers.quota.product.List}
                        onChanged={(entity) => this.setState({ selectedProductID: entity.getValueOne() ?? "NONE" })}
                        getTitle={(item) => item.name}
                        getValue={(item) => item.id}
                        getSort={() => null}
                    />
                    <NSSpace size={NSSpaceSizeType.MEDUIM} />
                    <NSRow style={{ alignItems: "stretch" }}>
                        {
                            <NSQAllUsageGauges
                                {...this.props}
                                filter={{
                                    product_id: this.state.selectedProductID
                                }}
                            />
                        }
                    </NSRow>
                </NSSection>
            </QuotaLayout>
        );
    }
}